import React from "react";
import numberToWord from "../../components/common/utlity/invoiceword";
import { useTranslation } from "react-i18next";
import { truncateCommaSeparatedString } from "../../components/common/utlity/utility";
import { AWS_URL } from "../../services/http.service";
const TaxInvoice1 = ({
  item,
  containerRef,
  businessName,
  phone,
  selectedColor,
  darkMode = false,
  bussiness,
}) => {

  const { t } = useTranslation();
  const currencySymbol = "₹";
  const decimalPlaces = 2;

  if (!item) return <div>No invoice data available</div>;

  const totalQuantity =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce((sum, i) => sum + (i.quantity || 0), 0) || 0;
  const totalTax =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce(
      (sum, i) =>
        sum +
        (i.salePrice || 0) * (i.quantity || 0) * ((i.igst || 0) / 100 || 0),
      0
    ) || 0;
  const totalAmount =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce((sum, i) => sum + (i.finalPrice || 0), 0) || 0;
  const amountInwords = numberToWord(totalAmount);

  const taxGroups = {};
  (item?.invoiceId?.startsWith("RT")
    ? item?.returnitems
    : item?.items
  )?.forEach((itm) => {
    const rate = itm.igst || 0;
    if (!taxGroups[rate]) {
      taxGroups[rate] = {
        taxableAmount: 0,
        taxAmount: 0,
        rate,
      };
    }
    taxGroups[rate].taxableAmount += (itm.salePrice || 0) * (itm.quantity || 0);
    taxGroups[rate].taxAmount +=
      ((itm.salePrice || 0) * (itm.quantity || 0) * rate) / 100;
  });

  const formatDate = (str) => {
    const date = new Date(str);
    if (!str || isNaN(date)) return str || "-";
    return date.toLocaleDateString();
  };

  return (
    <div
      className={`bg-white flex justify-center p-4 relative text-gray-900`}
      ref={containerRef}
    >
      {/* TAX INVOICE Title */}
      <div
        className={`absolute -top-[0%] left-1/2 -translate-x-1/2 bg-white px-1 text-[10px] font-bold ${
          darkMode ? "dark:bg-[#020617] text-white" : ""
        }`}
      >
        {t("NEWINVOICE.TAX_INVOICE")}:
      </div>

      <div className='w-full max-w-5xl border border-gray-400 font-sans text-[10px]'>
        {/* Store Name and Phone */}
        <div
          className={`text-center border-b border-gray-400 py-1 font-bold text-[12px] ${selectedColor}`}
          style={{ color: "inherit" }}
        >
          <div className='flex items-center justify-center gap-1'>
            {/* Business Logo */}
            <div className='w-4 h-4 rounded-full overflow-hidden flex items-center justify-center bg-gray-100 shadow'>
              <img
                src={
                  bussiness?.businesslogo
                    ? AWS_URL + bussiness.businesslogo
                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                }
                alt='Business Logo'
                className='object-contain w-full h-full'
                // crossOrigin='anonymous'
              />
            </div>

            {/* Business Name */}
            <span>{businessName || "Business Name"}</span>
          </div>
          <div className='text-[8px] font-normal'>
            {t("NEWINVOICE.PHONE")}: {phone || "-"}
          </div>
        </div>

        {/* Bill To and Invoice Details Header */}
        <div
          className={`grid grid-cols-12 border-b border-gray-400 text-[10px] font-semibold text-white ${selectedColor}`}
        >
          <div className='col-span-6 px-1 py-0.5'>
            {" "}
            {t("NEWINVOICE.BILL_TO")}
          </div>
          <div className='col-span-6 px-1 py-0.5 text-right'>
            {t("NEWINVOICE.INVOICE_DETAILS")}
          </div>
        </div>

        {/* Bill To and Invoice Details Content */}
        <div className='border border-gray-400 rounded-sm m-1'>
          <div className='grid grid-cols-12 text-[10px]'>
            <div className='col-span-6 px-1 py-1'>
              <div className='font-bold'>{item.customerName || "-"}</div>
              <div>
                {" "}
                {t("NEWINVOICE.CONTACT_NO")} : {item.mobile || "-"}
              </div>
            </div>
            <div className='col-span-6 px-1 py-1 text-right'>
              <div>
                {" "}
                {t("NEWINVOICE.NO")}: {item.invoiceId || "-"}
              </div>
              <div>
                {" "}
                {t("NEWINVOICE.DATE")}: {formatDate(item.saleDate)}
              </div>
            </div>
          </div>
        </div>

        {/* Table Header for Items */}
        <div
          className={`grid grid-cols-12 border-b border-gray-400 text-[10px] font-semibold text-white ${selectedColor}`}
        >
          <div className='col-span-1 px-1 py-0.5 border-r border-gray-400'>
            #
          </div>
          <div className='col-span-4 px-1 py-0.5 border-r border-gray-400'>
            {t("NEWINVOICE.ITEM_NAME")}
          </div>
          <div className='col-span-2 px-1 py-0.5 border-r border-gray-400'>
            {t("NEWINVOICE.HSN_SAC")}
          </div>
          <div className='col-span-1 px-1 py-0.5 border-r border-gray-400 text-center'>
            {t("NEWINVOICE.QTY")}
          </div>
          <div className='col-span-2 px-1 py-0.5 border-r border-gray-400 text-right'>
            {t("NEWINVOICE.PRICE_PER_UNIT")}
          </div>
          <div className='col-span-1 px-1 py-0.5 border-r border-gray-400 text-right'>
            {t("NEWINVOICE.GST")}
          </div>
          <div className='col-span-1 px-1 py-0.5 text-right'>
            {" "}
            {t("NEWINVOICE.AMOUNT")}
          </div>
        </div>

        {/* Table Body Items */}
        {(item?.invoiceId?.startsWith("RT")
          ? item?.returnitems
          : item?.items
        )?.map((itm, idx) => (
          <div
            key={idx}
            className='grid grid-cols-12 border-b border-gray-400 text-[10px]'
          >
            <div className='col-span-1 px-1 py-0.5 border-r border-gray-400 text-center'>
              {idx + 1}
            </div>
            <div className='col-span-4 px-1 py-0.5 border-r border-gray-400 font-bold'>
              {itm.productName || "-"}
            </div>
            <div className='col-span-2 px-1 py-0.5 border-r border-gray-400'>
              {truncateCommaSeparatedString(itm.hsnNumber) || "N/A"}
            </div>
            <div className='col-span-1 px-1 py-0.5 border-r border-gray-400 text-center'>
              {itm.quantity || 0}
            </div>
            <div className='col-span-2 px-1 py-0.5 border-r border-gray-400 text-right'>
              {currencySymbol}{" "}
              {(itm.salePrice || 0).toLocaleString(undefined, {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
              })}
            </div>
            <div className='col-span-1 px-1 py-0.5 border-r border-gray-400 text-right'>
              {currencySymbol}{" "}
              {(
                (itm.salePrice || 0) *
                (itm.quantity || 0) *
                ((itm.igst || 0) / 100)
              ).toLocaleString(undefined, {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
              })}{" "}
              ({itm.igst || 0}%)
            </div>
            <div className='col-span-1 px-1 py-0.5 text-right'>
              {currencySymbol}{" "}
              {(itm.finalPrice || 0).toLocaleString(undefined, {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
              })}
            </div>
          </div>
        ))}

        {/* Total Row */}
        <div className='grid grid-cols-12 border-b border-gray-400 text-[10px] font-semibold'>
          <div className='col-span-1 px-1 py-0.5 border-r border-gray-400 text-center'></div>
          <div className='col-span-4 px-1 py-0.5 border-r border-gray-400'>
            {t("NEWINVOICE.TOTAL")}
          </div>
          <div className='col-span-2 px-1 py-0.5 border-r border-gray-400'></div>
          <div className='col-span-1 px-1 py-0.5 border-r border-gray-400 text-center'>
            {totalQuantity}
          </div>
          <div className='col-span-2 px-1 py-0.5 border-r border-gray-400 text-right'></div>
          <div className='col-span-1 px-1 py-0.5 border-r border-gray-400 text-right'>
            {currencySymbol}{" "}
            {totalTax.toLocaleString(undefined, {
              minimumFractionDigits: decimalPlaces,
              maximumFractionDigits: decimalPlaces,
            })}
          </div>
          <div className='col-span-1 px-1 py-0.5 text-right'>
            {currencySymbol}{" "}
            {totalAmount.toLocaleString(undefined, {
              minimumFractionDigits: decimalPlaces,
              maximumFractionDigits: decimalPlaces,
            })}
          </div>
        </div>

        {/* Tax Details and Amounts Summary */}
        <div className='grid grid-cols-2 gap-x-0 border-t border-gray-400 mt-1 text-[10px]'>
          {/* Tax Details Table */}
          <div className='border border-gray-400 rounded-sm'>
            <div
              className={`text-white font-semibold px-1 py-0.5 border-b border-gray-400 ${selectedColor}`}
            >
              {t("NEWINVOICE.DETAILS")}
            </div>
            <table className='w-full text-left border-collapse'>
              <thead className='bg-gray-100 border-b border-gray-400'>
                <tr>
                  <th className='border-r border-gray-300 px-1 py-0.5'>
                    {t("NEWINVOICE.TAX_TYPE")}
                  </th>
                  <th className='border-r border-gray-300 px-1 py-0.5 text-right'>
                    {t("NEWINVOICE.TAXABLE_AMOUNT")}
                  </th>
                  <th className='border-r border-gray-300 px-1 py-0.5 text-center'>
                    {t("NEWINVOICE.RATE")}
                  </th>
                  <th className='px-1 py-0.5 text-right'>
                    {" "}
                    {t("NEWINVOICE.TAX_AMOUNT")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.values(taxGroups).map((tax, idx) => (
                  <tr key={idx}>
                    <td className='px-1 py-1 border-t border-gray-300'>
                      {t("NEWINVOICE.IGST")}
                    </td>
                    <td className='px-1 py-1 text-right border-t border-gray-300'>
                      {currencySymbol}{" "}
                      {tax.taxableAmount.toLocaleString(undefined, {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces,
                      })}
                    </td>
                    <td className='px-1 py-1 text-center border-t border-gray-300'>
                      {tax.rate}%
                    </td>
                    <td className='px-1 py-1 text-right border-t border-gray-300'>
                      {currencySymbol}{" "}
                      {tax.taxAmount.toLocaleString(undefined, {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces,
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Amounts Summary */}
          <div className='border border-gray-400 rounded-sm'>
            <div
              className={`text-white font-semibold px-1 py-0.5 border-b border-gray-400 ${selectedColor}`}
            >
              {t("NEWINVOICE.AMOUNT")}
            </div>
            <table className='w-full text-[10px]'>
              <tbody>
                <tr>
                  <td className='text-left px-1 py-1'>
                    {t("NEWINVOICE.SUB_TOTAL")}
                  </td>
                  <td className='text-right px-1 py-1 font-semibold'>
                    {currencySymbol}{" "}
                    {(item?.invoiceId?.startsWith("RT")
                      ? item?.returnitems
                      : item?.items
                    )
                      ?.reduce(
                        (sum, i) =>
                          sum + (i.salePrice || 0) * (i.quantity || 0),
                        0
                      )
                      .toLocaleString(undefined, {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces,
                      })}
                  </td>
                </tr>
                {item.cgst > 0 && (
                  <tr>
                    <td className='text-left px-1 py-1'>{t("TAX_WITHOUT_PERC.CGST")}</td>
                    <td className='text-right px-1 py-1 font-medium'>
                      {currencySymbol}{" "}
                      {parseFloat(item.cgst).toLocaleString(undefined, {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces,
                      })}
                    </td>
                  </tr>
                )}
                {item.sgst > 0 && (
                  <tr>
                    <td className='text-left px-1 py-1'>{t("TAX_WITHOUT_PERC.SGST")}</td>
                    <td className='text-right px-1 py-1 font-medium'>
                      {currencySymbol}{" "}
                      {parseFloat(item.sgst).toLocaleString(undefined, {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces,
                      })}
                    </td>
                  </tr>
                )}
                {item.igst > 0 && (
                  <tr>
                    <td className='text-left px-1 py-1'>{t("TAX_WITHOUT_PERC.IGST")}</td>
                    <td className='text-right px-1 py-1 font-medium'>
                      {currencySymbol}{" "}
                      {parseFloat(item.igst).toLocaleString(undefined, {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces,
                      })}
                    </td>
                  </tr>
                )}
                {item.cess > 0 && (
                  <tr>
                    <td className='text-left px-1 py-1'>{t("TAX_WITHOUT_PERC.CESS")}</td>
                    <td className='text-right px-1 py-1 font-medium'>
                      {currencySymbol}{" "}
                      {parseFloat(item.cess).toLocaleString(undefined, {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces,
                      })}
                    </td>
                  </tr>
                )}
                <tr>
                  <td className='text-left px-1 py-1 font-semibold'>
                    {t("NEWINVOICE.TOTAL")}
                  </td>
                  <td className='text-right px-1 py-1 font-bold'>
                    {currencySymbol}{" "}
                    {totalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: decimalPlaces,
                      maximumFractionDigits: decimalPlaces,
                    })}
                  </td>
                </tr>
                <tr>
                  <td className='text-left px-1 py-1'>
                    {t("NEWINVOICE.RECEIVED")}
                  </td>
                  <td className='text-right px-1 py-1'>
                    {currencySymbol}{" "}
                    {(item.amountReceived || 0).toLocaleString(undefined, {
                      minimumFractionDigits: decimalPlaces,
                      maximumFractionDigits: decimalPlaces,
                    })}
                  </td>
                </tr>
                <tr>
                  <td className='text-left px-1 py-1 font-semibold'>
                    {t("NEWINVOICE.BALANCE")}
                  </td>
                  <td className='text-right px-1 py-1 font-semibold'>
                    {currencySymbol}{" "}
                    {(totalAmount - (item.amountReceived || 0)).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces,
                      }
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Invoice Amount In Words and Payment Mode */}
        <div className='grid grid-cols-2 gap-x-0 border-t border-gray-400 mt-1 text-[10px]'>
          <div
            className={`border border-gray-400 rounded-sm w-full ${selectedColor}`}
          >
            <div
              className={`text-white font-semibold px-1 py-0.5 border-b border-gray-400 text-center`}
            >
              {t("NEWINVOICE.AMOUNT_IN_WORDS")}
            </div>
            <div className='px-1 py-1 text-center capitalize'>
              {amountInwords} {t("NEWINVOICE.ONLY")}
            </div>
            <div
              className={`text-white font-semibold px-1 py-0.5 border-t border-gray-400 text-center`}
            >
              {t("NEWINVOICE.PAYMENT_MODE")}
            </div>
            <div className='px-1 py-1 text-center'>
              {item.paymentMode || "-"}
            </div>
          </div>

          <div className='border border-gray-400 rounded-sm w-full'>
            <div className='px-1 py-1 text-center'>&nbsp;</div>
            <div className='px-1 py-1 text-center'>&nbsp;</div>
          </div>
        </div>

        {/* Terms & Conditions and Signature */}
        <div className='grid grid-cols-12 gap-x-0 border-t border-gray-400 mt-1 text-[10px]'>
          <div className='col-span-6'>
            <div className='border border-gray-400 h-full'>
              <div
                className={`text-white font-semibold px-1 py-0.5 border-b border-gray-400 ${selectedColor}`}
              >
                {t("NEWINVOICE.TERMS_CONDITIONS")}
              </div>
              <div className='px-1 py-6'>
                {item.termsConditions || t("NEWINVOICE.THANKS_MESSAGE")}
              </div>
            </div>
          </div>

          <div className='col-span-6'>
            <div className='px-1 py-6 text-center flex flex-col justify-center h-full'>
              <div className='text-[9px] mb-6'>
                {t("NEWINVOICE.FOR_COMPANY", { company: businessName })}
              </div>
              <div className='font-bold text-[10px]'>
                {" "}
                {t("NEWINVOICE.AUTHORIZED_SIGNATORY")}
              </div>
            </div>
          </div>
        </div>
        {bussiness?.aadharPhoto && (
          <div class='flex w-1/2 p-4 bg-gray-100 rounded-lg'>
            <img
              src={AWS_URL + bussiness?.aadharPhoto}
              alt='Payment QR Code'
              class='w-30 object-contain'
              // crossOrigin='anonymous'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TaxInvoice1;
